import {
  Box,
  TextField,
  Grid,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  Typography,
  Paper,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React, { ChangeEvent, useState, useEffect } from "react";
import { FormData } from "..";
import { useUsuario } from "../../../../Hooks/UsuarioHook";
import { useUsuarioStorage } from "../../../../Storage/UsuariosStorage";

interface Props {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  formValid: boolean;
  setFormValid: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Senha = ({
  formData,
  setFormData,
  formValid,
  setFormValid,
}: Props) => {
  const { manterAutenticado, setManterAutenticado, usuario } = useUsuario();
  const { usuarioFocus } = useUsuarioStorage();

  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const errors: { [key: string]: string } = {};

    if (formData.senha) {
      if (formData.senha.length < 4) {
        errors.senha = "A senha deve ter no mínimo 4 caracteres.";
      }
      if (!formData.confirmarSenha) {
        errors.confirmarSenha = "Confirme sua senha.";
      } else if (formData.senha !== formData.confirmarSenha) {
        errors.confirmarSenha = "As senhas não coincidem.";
      }
    }

    setFormErrors(errors);
    setFormValid(Object.keys(errors).length === 0);
  }, [formData, setFormValid]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            type={showPassword ? "text" : "password"}
            label="Senha"
            name="senha"
            value={formData.senha}
            onChange={handleChange}
            margin="normal"
            error={!!formErrors.senha}
            helperText={
              formErrors.senha ||
              "Deixe em branco se não quiser alterar a senha"
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            type={showConfirmPassword ? "text" : "password"}
            label="Confirmar Senha"
            name="confirmarSenha"
            value={formData.confirmarSenha}
            onChange={handleChange}
            margin="normal"
            error={!!formErrors.confirmarSenha}
            helperText={formErrors.confirmarSenha}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        {usuario?.usuario?.id === usuarioFocus?.usuario?.id && usuarioFocus?.usuario?.id && (
          <Grid item xs={12}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                borderRadius: 2,
                backgroundColor: "action.hover",
                display: "flex",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <Checkbox
                checked={!!manterAutenticado}
                onChange={() => {
                  setManterAutenticado((prev) =>
                    prev
                      ? null
                      : `{"id":"${usuario.usuario.id}","senha":"${usuario.usuario.senha}"}`
                  );
                }}
              />
              <Box>
                <Typography variant="subtitle1" fontWeight="bold">
                  Manter autenticado
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Se ativado, você não precisará digitar sua senha neste
                  navegador.
                </Typography>
              </Box>
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
